import Phaser from 'phaser';

/** Floating combat-text helper. Spawns a short-lived label that drifts up and fades. */
export function spawnDamageNumber(
  scene: Phaser.Scene,
  x: number,
  y: number,
  text: string,
  color: string = '#ff4444',
): void {
  const label = scene.add.text(x, y, text, {
    fontFamily: 'monospace',
    fontSize: '14px',
    color,
    stroke: '#000',
    strokeThickness: 3,
  });
  label.setOrigin(0.5, 1);
  label.setDepth(1_000_000);
  scene.tweens.add({
    targets: label,
    y: y - 30,
    alpha: 0,
    duration: 700,
    ease: 'Cubic.easeOut',
    onComplete: () => label.destroy(),
  });
}

/** Brief attack flash from attacker to target. */
export function spawnAttackArc(
  scene: Phaser.Scene,
  fromX: number,
  fromY: number,
  toX: number,
  toY: number,
  color: number = 0xffd54a,
): void {
  const g = scene.add.graphics();
  g.setDepth(1_000_001);
  g.lineStyle(2, color, 0.9);
  g.beginPath();
  g.moveTo(fromX, fromY);
  g.lineTo(toX, toY);
  g.strokePath();
  scene.tweens.add({
    targets: g,
    alpha: 0,
    duration: 180,
    onComplete: () => g.destroy(),
  });
}
